import { ref, onMounted, onBeforeUnmount } from 'vue';

/**
 * Types each text out character by character, holds it, erases it, then moves
 * on to the next one, looping forever while the component is mounted. Returns
 * the visible `text` and the `index` of the text being typed.
 *
 * Delays are in ms. With `jitter`, every delay is randomised (1-101% of its
 * value) for a more human typing rhythm.
 */
export function useTypewriter(texts, { typeDelay = 100, eraseDelay = 20, holdDelay = 2000, jitter = false } = {}) {
    const text = ref('');
    const index = ref(0);
    let length = 0;
    let typing = true;
    let timer = null;

    const tick = () => {
        let delay;
        if (typing && length < texts[index.value].length) {
            length++;
            delay = typeDelay;
        } else if (typing) {
            typing = false;
            delay = holdDelay;
        } else if (length > 0) {
            length--;
            delay = eraseDelay;
        } else {
            typing = true;
            index.value = (index.value + 1) % texts.length;
            delay = typeDelay;
        }
        if (jitter) delay *= Math.random() + 0.01;

        timer = setTimeout(() => {
            text.value = texts[index.value].slice(0, length);
            tick();
        }, delay);
    };

    onMounted(tick);
    onBeforeUnmount(() => clearTimeout(timer));

    return { text, index };
}
